import React from 'react'
// import styles from "./contact.module.css"
const Inputdata = () => {
  return (
    <div name='contact'  style={{"marginTop":"80px"}} >
        <form method='POST' action='https://getform.io/f/2698a552-d657-4123-afd0-ccd1a3f90c3f'  >
            <div className='pb-4'>
                {/* <p >Contact</p>
                <p>Connect with me via Email and call</p>
                <p >Email :- adityakothari7062@gmail.com</p>
                <p >contact:-+91-7976915124</p> */}
            </div>
            <br/>
            <input  type="text" placeholder='Name' name='name'style={{borderRadius:"5px","height":"30px","width":'22%'}} />
            <br/>
            <input  type="email" placeholder='E-mail' name='email'style={{borderRadius:"5px","marginTop":"15px","height":"30px","width":'22%'}} />
            <br/>
            <textarea  name='message' cols='30' rows='6' placeholder='Message' style={{borderRadius:"5px","marginTop":"15px","width":'22%'}}></textarea>
            <br/>
            <button style={{"width":"100px","color":"white","backgroundColor":"black","padding":"5px","borderRadius":"5px"}}>Submit</button>
        </form>

    </div>
  )
}

export default Inputdata



